<template>
  <div class="trip">
    <p class="title">选择出行方式</p>
    <ul class="trafficList">
      <li :class="traffic_i === index ? 'on' : ''" class="trafficItem" v-for="(item, index) in traffic" :key="index" @click="trafficClick(index, item.name)">{{item.name}}</li>
    </ul>
    <ul class="ranklist">
      <li class="rankItem" ref="items" v-for="(item, index) in rank" :key="index" @click="rankClick($event, item)">{{item.name}}</li>
    </ul>
  </div>
</template>

<script>
import {reqTravelWay,reqSeatType} from '../../api/index'
export default {
  props: ['travelMode', 'seatName'],
  data () {
    return {
      traffic: [],
      rank: [],
      traffic_i: '',
      refereeArr: [],
    }
  },
  mounted() {
    this.getWay()
    setTimeout(() => {
      if(this.traffic){
        this.traffic.map((item, index) => {
          if(item.name == this.travelMode) {
            this.traffic_i = index
            setTimeout(() => {
              this.$nextTick(() =>{
                this.trafficClick(index, this.travelMode)
              })
            },0)
          }
        })
      } else {
        setTimeout(() => {
          this.traffic.map((item, index) => {
            if(item.name == this.travelMode) {
              this.traffic_i = index
              setTimeout(() => {
                this.$nextTick(() =>{
                  this.trafficClick(index, this.travelMode)
                })
              },0)
            }
          })
        },200)
      }
    },500)
  },
  methods: {
    //获取出行方式
    getWay () {
      reqTravelWay().then(res => {
        if(res.code === 200){
          this.traffic = res.data.bussData
        }
      })
    },
    trafficClick (i, type) {
      this.traffic_i = i
      reqSeatType(type).then(res => {
        console.log(res)
        if(res.code === 200){
          this.rank = res.data.bussData
          if(this.seatName) {
            this.rank.forEach((item1, index1) => {
              this.seatName.split(',').forEach((item2, index2) => {
                if(item1.name == item2) {
                  console.log(item1)
                  //  就离谱
                  // this.refereeArr.push(item1)
                  // this.$nextTick(() => {
                  //   this.$refs.items[index1].className = 'rankItem on'
                  //   // 按理说你执行完选中却没有进入就离谱
                  // })
                }
              })
            })

          }
        }
      })
    },
    rankClick (e, text) {
      console.log("选择我",e)
      if (e.target.className.indexOf('on') === -1) {
        e.target.className = 'rankItem on' // 选中
        this.refereeArr.push(text)
      } else {
        e.target.className = 'rankItem'// 反选
        for (var i = 0; i < this.refereeArr.length; i++) {
          if (this.refereeArr[i] === text) {
            this.refereeArr.splice(i, 1)
            break
          }
        }
      }
      const trip = document.querySelector('.trafficList .trafficItem.on').innerHTML
      this.$emit('way', this.refereeArr, trip)
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
  .trip{
    .trafficList{
      display: flex;
      flex-wrap: wrap;
      margin-top:20px;
      .trafficItem{
        width: 115px;
        height: 38px;
        margin-right: 20px;
        font-size: 18px;
        line-height: 38px;
        text-align: center;
        border-radius: 19px;
        box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
        cursor: pointer;
      }
    }
    .ranklist{
      display: flex;
      flex-wrap: wrap;
      margin-top:40px;
      .rankItem{
        width: 80px;
        height: 30px;
        margin-right: 20px;
        margin-bottom: 20px;
        line-height: 30px;
        text-align: center;
        border-radius: 15px;
        box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
        cursor: pointer;
      }
    }
    .on{
      background: #61aee6;
      color:#fff;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Courier/Trip.vue